import { Select } from "@radix-ui/react-select";
import { useI18nContext } from "~/i18n/i18n-react";
import type { Locales } from "~/i18n/i18n-types";
import { logger as globalLogger } from "~/utils/logger-v2";
import { setStoredLocale, useLocale } from "~/utils/use-locale";
import {
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from "../ui/select";

const logger = globalLogger.namespace("[Language]");

const LanguageSelect = () => {
	const locale = useLocale() as Locales;
	const { LL, setLocale } = useI18nContext();

	const onLanguageSwitched = (
		newLocale: "en" | "ar" | "es" | "ca" | "pt" | "ee" | "ru" | "mt" | "tl"
	) => {
		logger.info("Language switched", { locale: newLocale });
		setLocale(newLocale);
		setStoredLocale(newLocale);
	};

	return (
		<Select
			value={locale}
			onValueChange={(
				language: "en" | "ar" | "es" | "ca" | "pt" | "ee" | "ru" | "mt" | "tl"
			) => onLanguageSwitched(language)}
		>
			<SelectTrigger>
				<SelectValue placeholder={LL.CREATE_ROOM_FORM.LANGUAGE_PLACEHOLDER()} />
			</SelectTrigger>
			<SelectContent>
				<SelectItem value="en">English (United States)</SelectItem>
				<SelectItem value="ar">العربية (السعودية)</SelectItem>
				<SelectItem value="es">Español (Costa Rica)</SelectItem>
				<SelectItem value="ca">Català (Espanya)</SelectItem>
				<SelectItem value="pt">Português (Portugal)</SelectItem>
				<SelectItem value="ee">Eesti (Eesti)</SelectItem>
				<SelectItem value="ru">Русский (Россия)</SelectItem>
				<SelectItem value="mt">Malti (Malta)</SelectItem>
				<SelectItem value="tl">Filipino (Pilipinas)</SelectItem>
			</SelectContent>
		</Select>
	);
};

export default LanguageSelect;
